import { render, staticRenderFns } from "./Fullscreenmodal.vue?vue&type=template&id=52d7e884&scoped=true&"
import script from "./Fullscreenmodal.vue?vue&type=script&lang=js&"
export * from "./Fullscreenmodal.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreenmodal.vue?vue&type=style&index=0&id=52d7e884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7e884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBadge,VBtn,VCard,VCol,VDialog,VIcon,VRow,VSelect})
